module.exports = __webpack_public_path__ + "img/logo.bfadf4d9.svg";